/**
 * 「PDFで出力する（新レイアウト・試行中）」ボタンの表示制御（issue #995）。
 *
 * rust-pdf による新しい PDF 出力は、既存の「PDFで出力する」ボタン（pdf-api 経由）と
 * 並べて本番で並行運用する。お客様に見せる前に社内の端末だけで確認できるよう、
 * 次の優先順で表示を決める。
 *
 *   1. localStorage の `showNewPdfButton`（"1" で表示 / "0" で非表示。社内の端末で先行表示する用）
 *   2. ビルド時の環境変数 `VUE_APP_SHOW_NEW_PDF_BUTTON`（"true" で表示）
 *   3. 既定は非表示
 *
 * 社内の端末では、ブラウザの開発者ツールで
 * `localStorage.setItem('showNewPdfButton', '1')` を実行してから画面を再読み込みする。
 */

/** localStorage のキー */
export const NEW_PDF_BUTTON_STORAGE_KEY = "showNewPdfButton";

/**
 * localStorage から値を読む。読めない環境（プライベートブラウズ等）では null を返す
 * @param {string} key キー
 * @returns {string|null} 値
 */
function safeLocalStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

/**
 * 新しい PDF 出力ボタンを表示するか
 * @returns {boolean} 表示する場合は true
 */
export function isNewPdfButtonVisible() {
  const override = safeLocalStorageGet(NEW_PDF_BUTTON_STORAGE_KEY);
  if (override === "1") return true;
  if (override === "0") return false;
  return process.env.VUE_APP_SHOW_NEW_PDF_BUTTON === "true";
}

export default {
  isNewPdfButtonVisible,
};
